// Hero.js (example)
import { useState, useEffect } from 'react';
import { animated, useSpring } from 'react-spring'; // Animation library
import styled from 'styled-components';

const Hero = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
//    const trigger = useScrollTrigger({ onEnter: () => setIsScrolled(true), onLeave: () => setIsScrolled(false) });
//    return () => trigger.cleanup();
  }, []);

  const heroAnimation = useSpring({
    from: { opacity: 0 },
    to: { opacity: isScrolled ? 1 : 0 },
    config: { duration: 1000 },
  });

  return (
    <HeroContainer style={heroAnimation} id="about">
    </HeroContainer>
  );
};


const HeroContainer = styled.div`
  background-image: url('images/landing.jpg');
  background-size: cover;
  background-position: center;
  height: 90vh;
  opacity: 0.6;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
`;

export default Hero;

